export const YYYY = 'YYYY';
export const MM = 'MM';
export const HH = 'HH';
export const MONTH_TIME_UNIT = 'M';
export const DAY_TIME_UNIT = 'd';
export const HOUR_TIME_UNIT = 'h';
export const FULL_DATE_FORMAT = 'dddd MMM D, YYYY';
